import React from 'react';

interface HeaderProps {
  currentPage: string;
}

const Header: React.FC<HeaderProps> = ({ currentPage }) => {
  return (
    <div className="header">
      <h1 id={currentPage}>
        EMILY <span style={{ fontFamily: 'Edgethorn' }}>&</span> ARIAN
      </h1>
    </div>
  );
};

export default Header;
